export default function toggleItems(btn, elem) {
    const button = btn;
    const showElem = elem;

    button.addEventListener('click', (e) => {
        e.preventDefault();
        if (showElem.hasAttribute('hidden')){
            showElem.hidden = false;
            button.classList.remove('collapsed');
            button.classList.add('expanded');
            button.setAttribute('aria-expanded', 'true');
        } else {
            showElem.hidden = true;
            button.classList.remove('expanded');
            button.classList.add('collapsed');
            button.setAttribute('aria-expanded', 'false');
        }
    });
}

